import React from "react";

const EditPencilIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="22" height="22" fill="url(#pattern0_2195_478)" />
      <defs>
        <pattern
          id="pattern0_2195_478"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use href="#image0_2195_478" transform="scale(0.01)" />
        </pattern>
        <image
          id="image0_2195_478"
          width="100"
          height="100"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD5klEQVR4nO2du2sUQRzHvyncoKCFr/ioFLV1s5h/wEoUgyIpLLQWE0h8BgsttBSbqIWtYh0T8NGIhUpQ4wOJYBFURPF5pjMY1MjAHJ6Huzu789vduZvvBwbCZXd2bz/5zfz2N5c9gBBCCCGEEEIIIaRVWA1gD4ABAKd1G9Cvrar65HxhCYATACYB/AYwH9PU7x7pbdU+RJhOAEcBfE2QENe+ADii+yACbADwJIeI5vYYwHqJE/KZbgCfBGTU20cAm6t+U61KBKAmKKNRCiOlIBk/9XA2rttTAL8M9lNJAecUQRlqcj8GYMV/9levHTfo47DpCflMaJBJ3QfQZdDXcgB3UrIvpsQpE3jaX/UYgADmqGHpbkJ/wxn68oruAmTU6Uro+2EB76Xl6S5QRp3hmH5VAsAyS8kyFCsTsq/dln17lU2NCcio8yzmGP1C/bd9NnVd+F5hPOY4Z+A5EYBvBjdvvcLHpRALGarNAtgGOeKGrIPwlCiDDGkpSZP6LnhIlEOGpJSktNfkrt87GW8KlNKVcPwH8IzIMLVV2dTFAqSolPleQp+qCOkNoUFqe6Mhte0AMJKy/Q8AOzPIuJZSXFwMTwgzyoCwlDQZqh2CJ4Q5ZUhJMZExKVgB8KIc0pFzTgl0/0n7fQCwDh4QCdemskoxkVHTEdz2RAUVCk2l9BrKUOfZ9oSWc0YaJnNKWpsB0AMPCEuq2tpIoQzIyrCRQhkoRkYeKUrGFnhAVPJKXzOdBrWvml4ebnvCClb6st70MTJQTmSY3md4ERlRxcMUZTTAYcohKMMhKMMhKMMhKMMhKMMhKMMhKMMhKMMhKMMhKMMhKMMhKMMhKMMhKKPF/ttVrcRxPaMElgJ4XfGy6yiXXf9ylZHhDmsBzDk+TEXwiCHHh6keeMatmIsxxcgon4UAvscIOVnQMQNGRjw7EoaLrQXJGOOcEc+FhIvzUj8ZWlLGKOeMZKZTLpCUlIAy0tlk+AlxWykBZZgxaCjERkpAGfbprpSUgDJk0l0JKQFlZGN7wkV/nyLlRcrTcQKmtnLp7md9sZ/njJSAkSGb7l5ueBR3VikBZcinu3ubnrA2ZTB8qTv6U/rn+YTmXdXWNt1V3yKwrGlbk0gxaTM+Vm1NuRlz0SZitldPdX5nIaPGyLCv7qpI6QNwySDrYmQUlO4e0FIm9PBlO0y99eWpOjacF7jQaW0OwBX93RzEsrqbt83qUswQgDW0IFvdNW2v9BzT59ODIiXpF4qCQS2XWHIuh4RpXWZRycAi2xMg/7KfUeAWCwDcjokClX0xCiqSsg/AWT2nbKziJAghhBBCCCGEEEJQCn8ApW/iRV9S2PYAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export default EditPencilIcon;
